<template>
	<label @click="$event.stopPropagation()" class="check"> {{name}}
	<input @change="toggle" type="checkbox" :checked="value">
  <span id="checkbox" :style="curColor" class="checkmark border "></span>
	</label>
</template>
<script>
export default {
	props: {
		value: {
			type: Boolean,
			required: true,
			default: false
		},
    color: {
      type: String,
    },
		name: {
			type: String,
			default: ""
		}
	},
  computed: {
    curColor() {
      return `background-color: ${this.color}; border-color: ${this.color}`
    }
  },
  methods: {
    toggle() {
      this.$emit("checked", this.color)
    }
  }
}
</script>
<style lang="scss" scoped>

.check {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.check input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  bottom: -7px;
  left: 0;
  height: 25px;
  width: 25px;
}


/* When the checkbox is checked, add a blue background */
// .check input:checked ~ .checkmark {
//   background-color: color(lms-tenant);
// }

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.check input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.check .checkmark:after {
  left: 7px;
  top: 3px;
  width: 8px;
  height: 14px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>